"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonCircularStyled = exports.ButtonRegularStyled = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const oxygen_constants_1 = require("@8x8/oxygen-constants");
const button_utils_1 = require("./button.utils");
exports.ButtonRegularStyled = styled_components_1.default.button `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  outline: none;

  ${props => {
    const { fontSize, fontFamily, fontWeight, lineHeight, letterSpacing } = (0, button_utils_1.getTypographyStyle)(props);
    return (0, styled_components_1.css) `
      font-size: ${fontSize};
      font-family: ${fontFamily};
      font-weight: ${fontWeight};
      line-height: ${lineHeight};
      letter-spacing: ${letterSpacing};
    `;
}};

  transition: ${({ variant, theme }) => {
    return variant === oxygen_constants_1.buttonVariant.tertiary ||
        variant === oxygen_constants_1.buttonVariant.tertiaryReversed
        ? `
      background-color ${theme.transitionDuration} ease-in-out 0s,
      border-color ${theme.transitionDuration} ease-in-out 0s,
      color ${theme.transitionDuration} ease-in-out 0s,
      box-shadow ${theme.transitionDuration} ease-in-out 0s
    `
        : `
      background-color ${theme.transitionDuration} ease-in-out,
      box-shadow ${theme.transitionDuration} ease-in-out 0s
    `;
}};

  & > svg {
    transition: ${({ theme }) => theme.transitionDuration} ease-in-out;
  }

  ${props => {
    const { width, height, padding, minHeight } = (0, button_utils_1.getSizeStyle)(props);
    return (0, styled_components_1.css) `
      ${minHeight && `min-height: ${minHeight};`}
      ${width && `width: ${width};`}
    ${height && `height: ${height};`}
    ${padding && `padding: ${padding};`}
    `;
}}

  &::-moz-focus-inner {
    border: none;
  }

  ${props => {
    const { backgroundColor, backgroundColorActive, backgroundColorDisabled, backgroundColorHover, borderColor, borderColorActive, borderColorDisabled, borderColorHover, borderSize, fontColor, fontColorActive, fontColorDisabled, fontColorHover, shadowBackgroundColorFocus, shadowColorFocus, } = (0, button_utils_1.getVariantStyle)(props);
    return `
      box-shadow: 0 0 0 ${borderSize ?? props.theme.borderSize} inset ${props.isActive ? borderColorActive : borderColor};
      border: none;
      border-radius: ${props.theme.borderRadius};
      background-color: ${props.isActive ? backgroundColorActive : backgroundColor};
      color: ${props.isActive && fontColorActive ? fontColorActive : fontColor};

      &:hover {
        background-color: ${backgroundColorHover};
        box-shadow: 0 0 0 ${borderSize ?? props.theme.borderSize} inset ${borderColorHover};
        color: ${fontColorHover};
      }

      &:active {
        background-color: ${backgroundColorActive};
        box-shadow: 0 0 0 ${borderSize ?? props.theme.borderSize} inset ${borderColorActive};
      }

      &[aria-disabled="true"] {
        background-color: ${backgroundColorDisabled};
        box-shadow: 0 0 0 ${borderSize ?? props.theme.borderSize} inset ${borderColorDisabled};
        color: ${fontColorDisabled};
        cursor: not-allowed;
      }

      &:focus-visible {
        ${shadowColorFocus
        ? `
            box-shadow: 0 0 0 2px inset ${shadowColorFocus}, 0 0 0 3px inset ${borderSize ? borderColor : shadowBackgroundColorFocus};
            &:hover {
              box-shadow: 0 0 0 2px inset ${shadowColorFocus}, 0 0 0 3px inset ${shadowBackgroundColorFocus};
            }
              `
        : `
              background-color: ${backgroundColorHover};
              border-color: ${borderColorHover};
            `}
      }
    `;
}}
`;
exports.ButtonCircularStyled = (0, styled_components_1.default)(exports.ButtonRegularStyled) `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 0;
`;
